import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as fromActions from '../actions';
import { map, switchMap } from "rxjs/operators";
import { FiltersService, MaterialesService } from '../services';
import { selectedFiltersSelector } from '../selectors';
import { Router } from "@angular/router";
import { ROUTER_PATH } from '../app-routing.module';
import { Filter } from '../models';
import { getLanguageFromUrl, LanguageId } from '../language';


@Injectable()
export class FiltersEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private materialesService: MaterialesService,
    private filtersService: FiltersService,
    private router: Router
  ) { }

  selectFilter = createEffect(() => this.actions$.pipe(
    ofType(fromActions.addSelectedFilter),
    switchMap(() => this.store.select(selectedFiltersSelector).pipe(
      map(filters => filters.length &&
        this.router.navigate([getLanguageFromUrl(), ROUTER_PATH.RESULTS, this.filtersService.serializeFiltersParams(filters)])
        )
    ))
  ), { dispatch: false })

  deselectFilter = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeSelectedFilter),
    switchMap(() => this.store.select(selectedFiltersSelector).pipe(
      map(filters => this.router.navigate([getLanguageFromUrl(), ROUTER_PATH.RESULTS, this.filtersService.serializeFiltersParams(filters)])),
    ))
  ), { dispatch: false })

  removeAllFilters = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeAllFilters),
    map(() => this.router.navigate([getLanguageFromUrl(), ROUTER_PATH.ROOT])),
    map(() => fromActions.setResultsCount({count: 0}))
  ))

  loadStockRequest = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadStockRequest),
    switchMap(({ filters, offset, limit }) => {
      const offsetParam: string = `offset=${offset}`;
      const limitParam: string = `limit=${limit}`;
      const filterParams: string[] = this.filtersService.serializeFiltersApiParams(filters);
      return this.materialesService.getStock([
        ...filterParams,
        offsetParam,
        limitParam,
      ]).pipe(
        map(stock => fromActions.loadStock({ stock }))
      )
    }
    )
  ))

  loadResultsCountRequest = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadResultsCountRequest),
    switchMap(({ filters }) => {
      const filterParams: string[] = this.filtersService.serializeFiltersApiParams(filters);
      return this.materialesService.getResultsCount(filterParams).pipe(
        map(count => fromActions.setResultsCount({ count: parseInt(count) }))
      )
    })
  ))

  deserializeFiltersUrl = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deserializeFiltersUrl),
    map(({ query }) => {
      const filters: Filter[] = this.filtersService.deserializeFiltersParams(query);
      return fromActions.setSelectedFilters({ filters })
    })
  ))

  loadCountFromUrl = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deserializeFiltersUrl),
    map(({ query }) => {
      const filters: Filter[] = this.filtersService.deserializeFiltersParams(query);
      return fromActions.loadResultsCountRequest({ filters })
    })
  ))

  setSelectedFilters = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deserializeFiltersUrl),
    map(({ query, limit, offset }) => {
      const filters: Filter[] = this.filtersService.deserializeFiltersParams(query);
      return fromActions.loadStockRequest({ filters, limit, offset })
    })
  ))

  loadFiltersFromMaestros = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadMaestrosMaterial),
    map(maestros => fromActions.addFilters({
      filters: this.filtersService.getFiltersFromMaestros(maestros)
    }))
  ))

}
